import React from 'react';

type SwitchProps = {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  'aria-label'?: string;
  /** dark = sidebar chrome; light = forms on white cards */
  surface?: 'dark' | 'light';
};

/** Compact accessible toggle — presentation only. */
export const Switch: React.FC<SwitchProps> = ({
  checked,
  onCheckedChange,
  disabled = false,
  id,
  'aria-label': ariaLabel,
  surface = 'dark',
}) => {
  const trackOff = surface === 'light' ? 'bg-neutral-200' : 'bg-white/25';
  const ringOffset =
    surface === 'light' ? 'focus-visible:ring-offset-white' : 'focus-visible:ring-offset-[#2D1537]';

  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F98C10]/50 focus-visible:ring-offset-2 ${ringOffset} disabled:cursor-not-allowed disabled:opacity-50 ${
        checked ? 'bg-[#F98C10]' : trackOff
      }`}
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform duration-200 ${
          checked ? 'translate-x-[18px]' : 'translate-x-0.5'
        }`}
      />
    </button>
  );
};

export default Switch;
